var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0513 35.7189C47.3077 20.4625 85.8975 14.1805 85.8975 14.1805C85.8975 14.1805 80.5129 40.4625 71.9231 57.2574L60.7693 53.6676L64.359 68.0266C46.6667 85.7189 26.1539 73.924 26.1539 73.924C26.1539 73.924 14.2308 53.5394 32.0513 35.7189Z",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3077 57.7702L14.1025 85.9753",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf1);
export default __webpack_public_path__ + "static/media/leaf-1.4c8946c259a9a06500ea7fa0b08c0125.svg";
export { ForwardRef as ReactComponent };